module.exports = __webpack_public_path__ + "assets/img/pjs_5.802e9f76.png";